/**
 * Retrieves the value of a specified cookie by its name.
 *
 * @param {string} name - The name of the cookie to retrieve.
 * @returns {string} - The value of the cookie, or an empty string if the cookie is not found.
 */
export function getCookieByName(name: string): string {
  const matches = document.cookie.match(`(^|; )${name}=([^;]*)`);
  return matches && matches[2] ? matches[2] : '';
}
